import { useEffect } from 'react'
import { NoticeStore } from '../../state/NoticeStore'
import AddToCartNotice from './AddToCartNotice'
import ErrorNotice from './ErrorNotice'
import StandardNotice from './StandardNotice'
import SuccessNotice from './SuccessNotice'
import SuccessNoticeCenter from './SuccessNoticeCenter'
import ErrorNoticeCenter from './ErrorNoticeCenter'

function Notices() {
    const notices = NoticeStore((state) => state.notices)
    const skim = NoticeStore((state) => state.remove)

    useEffect(() => {
        // Remove notices after a few seconds
        // const interval = setInterval(skim, 5000)
        // return () => clearInterval(interval)
    }, [])

    const noticesToShow = notices.map(({ type, children }, idx) => {
        return type === 'add-to-cart' ? (
            <AddToCartNotice key={idx} onRemove={skim} />
        ) : type === 'success-center' ? (
            <SuccessNoticeCenter key={idx} onRemove={skim}>
                {children}
            </SuccessNoticeCenter>
        ) : type === 'error-center' ? (
            <ErrorNoticeCenter key={idx} onRemove={skim}>
                {children}
            </ErrorNoticeCenter>
        ) : type === 'success' ? (
            <SuccessNotice key={idx} onRemove={skim}>
                {children}
            </SuccessNotice>
        ) : type === 'error' ? (
            <ErrorNotice key={idx} onRemove={skim}>
                {children}
            </ErrorNotice>
        ) : (
            <StandardNotice key={idx} onRemove={skim}>
                {children}
            </StandardNotice>
        )
    })

    if (noticesToShow.length < 1) return null

    return (
        <div className="">
            <div className="fixed inset-0 z-20 bg-black opacity-50"></div>
            <div className="absolute z-50">{noticesToShow}</div>
        </div>
    )
}

export default Notices
